module.exports = __webpack_public_path__ + "img/panel9.a7910c85.jpg";